import { error, pageInfo } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const chatHistory = gql`
  query GetChatConnection($first: Int, $after: String) {
    customerChatHistory(first: $first, after: $after) {
      __typename
      chatOutageMessage
      edges {
        cursor
        node {
          id
          sender
          createdAt
          eventType
          sessionId
          content {
            ... on ChatContentMessage {
              message
              __typename
            }
            ... on ChatContentHtml {
              html
              __typename
            }
            ... on ChatContentLexBotOption {
              __typename
              message
              action {
                ... on ChatBotAction {
                  id
                  copy
                  type
                  value
                  __typename
                }
                ... on ChatBotDeepLinkAction {
                  id
                  copy
                  type
                  link
                  __typename
                }
              }
            }
          }
        }
      }
      pageInfo {
        ...pageInfo
      }
      chatSession {
        ... on CustomerChatSessionSuccess {
          __typename
          sessionId
          isConnectedToAnAgent
          queuePositionMessage
        }
        ... on CustomerChatSessionNotFound {
          ...error
          __typename
        }
        ... on CustomerChatSessionError {
          ...error
          __typename
        }
      }
    }
  }
  ${pageInfo}
  ${error}
`;

export default chatHistory;
